export default __webpack_public_path__ + "static/media/never-expires.2a9c50fa.svg";